import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/see.png'


const _withScopeId = n => (_pushScopeId("data-v-d3022d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_header" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Suivre ma dénonciation", -1))
const _hoisted_5 = { class: "contexte" }
const _hoisted_6 = { class: "all" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "follow" }, " Pour suivre votre demande, veuillez renseigner le numéro de suivi et votre code secret à 4 chiffres ", -1))
const _hoisted_8 = { class: "first_line" }
const _hoisted_9 = { class: "organisme" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "organisme_label" }, "Numéro de suivi *", -1))
const _hoisted_11 = { class: "organisme_text" }
const _hoisted_12 = { class: "personne" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "personne_label" }, "Code secret *", -1))
const _hoisted_14 = { class: "personne_text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_follow" }, "VÉRIFIER", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderPage = _resolveComponent("HeaderPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderPage),
      _createElementVNode("footer", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reference) = $event)),
                    type: "text",
                    name: "organisme_text",
                    id: "organisme_text"
                  }, null, 512), [
                    [_vModelText, _ctx.reference]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                    type: "text",
                    name: "personne_text",
                    id: "personne_text"
                  }, null, 512), [
                    [_vModelText, _ctx.date]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", {
              class: "empty",
              style: _normalizeStyle(_ctx.empty == 'true' ? 'display:block;margin-top:20px' : 'display:none' )
            }, "Veuillez remplir tous les champs obligatoires", 4),
            _createElementVNode("div", {
              class: "plainte_send",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.follow && _ctx.follow(...args)))
            }, _hoisted_17)
          ])
        ])
      ])
    ])
  ]))
}